import { createFileRoute, redirect } from '@tanstack/react-router'

// Deprecated route kept so old bookmarks and links still work
export const Route = createFileRoute('/_a/templates/$templateId/versions/$versionId/edit')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/templates/$templateId/edit',
      params: { templateId: params.templateId },
      replace: true,
    })
  },
})
